import { oc } from '@orpc/contract';
import { z } from 'zod';

export const healthContract = {
  live: oc
    .route({ method: 'GET', path: '/health/live', summary: 'Liveness probe' })
    .input(z.object({}))
    .output(z.object({ status: z.literal('ok'), uptimeSeconds: z.number() })),

  ready: oc
    .route({ method: 'GET', path: '/health/ready', summary: 'Readiness probe' })
    .input(z.object({}))
    .output(
      z.object({
        status: z.enum(['ok', 'degraded']),
        checks: z.object({ database: z.boolean() }),
      }),
    ),
};
